import Logo from '../images/3keys1.jpg';
import Menu from '../components/menu';

export default function Hd(){
    return(
        <div className="hd-main">
            <div className="row hd">
                <div className="col-sm-6 hd-column1">
                    <img src={Logo} alt="3 Keys Logo" width="30%" />
                    <p className="text-primary" style={{fontWeight:"600"}}><i>Worldwide Freight Forwarders, Removal Customs Agent & Logistics Company</i></p>
                </div>
                <div className="col-sm-6 hd-column2">
                    <div className="hd-row1-text" style={{fontSize:"20px"}}>Hotlines: +234 706 737 0051, Email: info@3keyslogisticsltd.com.ng</div>
                    <br />
                    <div className="hd-row2-text"><Menu /></div>
                </div>
                
            </div>
        </div>
    );
}